<div class="d-flex justify-content-between align-items-center p-2 bg-white shadow-sm">
  <div class="d-flex align-items-center gap-3">
    <button id="toggleIcon" class="btn btn-link p-0 text-dark fs-5 toggleIcon" (click)="onToggle()">
      <i [ngClass]="isMenuOpen ? 'bi bi-x-lg' : 'bi bi-list'"></i>
    </button>
    <div class="input-group" style="width: 50px; visibility: hidden;">
      <span class="input-group-text bg-light border-0">
      </span>
      <input type="text" class="form-control border-0 bg-light" placeholder="Search..." />
    </div>
  </div>
  <div class="d-flex align-items-center gap-5">
    <div class="d-flex align-items-center gap-2">
      <div>
        <div class="fw-bold medium mb-0" style="font-size: 18px;">{{marketName}}</div>
      </div>
    </div>
    <button class="btn btn-light d-flex align-items-center gap-2 px-3 respDate">
      <i class="bi bi-calendar"></i>
      <span>{{marketDate}}</span>
    </button>
    <div class="d-flex align-items-center gap-2">
      <img src="./assets/images/profile.png" class="rounded-circle" style="width: 1.7rem;" />
      <div>
        <div class="fw-semibold medium mb-0">{{userName}}</div>
      </div>
    </div>
    <div class="dropdown" [class.show]="dropdownOpen" (document:click)="closeDropdownOnOutsideClick($event)">
      <button class="btn p-0 border-0 bg-transparent" #dropdownButton (click)="toggleDropdown($event)">
        <img src="./assets/images/more.svg" alt="Settings" />
      </button>

      <ul class="dropdown-menu dropdown-menu-end" #dropdownMenu [class.show]="dropdownOpen">
        <li>
          <a href="javascript:;" *ngIf="displaySwitchStore">
            <button class="bg-white border-none pb-1" style="border-bottom: 0.5px solid lightgrey;" (click)="onclickSwitchMarket()">
              <img style="width: 9%; margin-left: -11px;" class="img-fluid mr-2"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDkuNiA0MDkuNiIgZmlsbD0iI2Y0NjgwMSI+PGc+PHBhdGggZD0iTTM5Mi41MzUsMGgtMTcwLjY3Yy05LjM4LDAtMTcuMDY1LDcuNjg1LTE3LjA2NSwxNy4wNjV2MTAyLjRjMCw5LjM4NSw3LjY4NSwxNy4wNywxNy4wNjUsMTcuMDdoMTcwLjY3YzkuMzgsMCwxNy4wNjUtNy42ODUsMTcuMDY1LTE3LjA3di0xMDIuNEM0MDkuNiw3LjY4NSw0MDEuOTE1LDAsMzkyLjUzNSwwWiIvPjxwYXRoIGQ9Ik0xODcuNzM1LDI3My4wNjVIMTcuMDY1QzcuNjg1LDI3My4wNjUsMCwyODAuNzUsMCwyOTAuMTM1djEwMi40YzAsOS4zOCw3LjY4NSwxNy4wNjUsMTcuMDY1LDE3LjA2NWgxNzAuNjdjOS4zOCwwLDE3LjA2NS03LjY4NSwxNy4wNjUtMTcuMDY1di0xMDIuNEMyMDQuOCwyODAuNzUsMTk3LjExNSwyNzMuMDY1LDE4Ny43MzUsMjczLjA2NVoiLz48cGF0aCBkPSJNMTE5LjQ4NSw4NS4zMzVoNTEuMThWNTEuMmgtNTEuMThDODEuNzg3LDUxLjIsNTEuMiw4MS43NTEsNTEuMiwxMTkuNDV2NjEuMjE1bC0yNy4wNjQtMjcuMDQ5TDAsMTc3Ljc1MWw1Ni4yMDIsNTYuMTgyYzYuNjUxLDYuNjY2LDE3LjQ2NCw2LjY2NiwyNC4xMzYsMGw1Ni4yMDItNTYuMjAyTDExMi4zOTksMTUzLjZsLTI3LjA2NCwyNy4wNjR2LTYxLjIxNUM4NS4zNSwxMDAuNTk4LDEwMC42MzQsODUuMzM1LDExOS40ODUsODUuMzM1WiIvPjxwYXRoIGQ9Ik0zNTMuMzk4LDE3NS42NjdjLTYuNjUxLTYuNjY2LTE3LjQ2NC02LjY2Ni0yNC4xMzYsMGwtNTYuMTk3LDU2LjE5N0wyOTcuMjAxLDI1NmwyNy4wNjQtMjcuMDY0djYxLjIxNWMwLDE4Ljg1Mi0xNS4yODMsMzQuMTE1LTM0LjEzNSwzNC4xMTVoLTUxLjE4VjM1OC40aDUxLjE4YzM3LjY5OSwwLDY4LjI4NS0zMC41NTEsNjguMjg1LTY4LjI1di02MS4yMTVsMjcuMDY0LDI3LjA0OWwyNC4xMzYtMjQuMTM2WiIvPjwvZz48L3N2Zz4=">
              Switch Market</button></a>
          <a class="dropdown-item logout-item" (click)="logout()"><i class="bi bi-box-arrow-right" style="color: #f46801;"></i>&nbsp;Logout</a>
        </li>
      </ul>
    </div>

  </div>
</div>

<div class="modal fade" id="switchmarket" #switchmarket tabindex="-1" aria-labelledby="switchmarketLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Switch Market</h5>
      </div>
      <div class="modal-body">
        <div class="mx-0">
          <p>Markets : </p>
          <select id="markets" class="form-control" [(ngModel)]="lastAccessed">
            <option *ngFor="let mkt of marketList" [value]="mkt.MarketId">
              {{mkt.MarketName}}</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-orange mr-3" (click)="cancelSwitchMarket()" i18n>Cancel</button>
        <button type="button" class="btn btnAS" data-dismiss="modal"
          (click)="updateChangedMarket()">Select</button>
      </div>
    </div>
  </div>
</div>